import { render, staticRenderFns } from "./MoreProducts.vue?vue&type=template&id=7ca45f2c&scoped=true&"
import script from "./MoreProducts.vue?vue&type=script&lang=js&"
export * from "./MoreProducts.vue?vue&type=script&lang=js&"
import style0 from "./MoreProducts.vue?vue&type=style&index=0&id=7ca45f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca45f2c",
  null
  
)

export default component.exports